import { createContext, useContext, useSyncExternalStore } from 'react';

let currentMode = false;
let initialized = false;
const listeners = new Set<() => void>();

export const salesDemoStorageKey = 'ics-sales-demo-mode-change';
export const getSalesDemoMode = () => currentMode;
export const salesDemoModeInitialized = () => initialized;

export function setSalesDemoMode(enabled: boolean) {
  currentMode = enabled;
  initialized = true;
  listeners.forEach((listener) => listener());
}

export function useSalesDemoMode() {
  return useSyncExternalStore((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, getSalesDemoMode);
}

export function reloadProjectWorkspace() {
  // Hide the old workspace before navigation, including any cached production DOM.
  document.documentElement.style.visibility = 'hidden';
  window.location.replace('/projects');
}

export const SalesReadOnlyContext = createContext(false);
export const useSalesReadOnly = () => useContext(SalesReadOnlyContext);
